/*
 * TODO: SndMgr need to be refactored;
 * 1. use sound on/off instead of mute on/off which is double negative and leads all the confustion created here.
 * 2. PlaySound should just play sound not double checking play conditions.
 * 3. when refactor make sure all skins are checked.
 * 4. Unit tests are wrong since not enough Mock objects are created per each tests.
 *
 */

/**
 * Sound Manager - plays a sound to a customer for every agent response (if configured in skin).
 * <p>Supports "audiodatauri" (heavy-on-bandwidth feature) - base64-encoded sound, embedded into MXML
 * (in form of Data URI, i.e. URI with "data:" protocol).
 * <p>Sounds may be slow to load (esp. WAV sounds) - use lazyInit() to load on request
 * (e.g. when chat is engaged, but <b>after pre-chat survey</b>).
 * @author fpinn
 * @constructor
 */
com.inq.flash.client.chatskins.SndMgr = function() {
};
$hxClasses['com.inq.flash.client.chatskins.SndMgr'] = com.inq.flash.client.chatskins.SndMgr;
/** @private @type {Array} */
com.inq.flash.client.chatskins.SndMgr.__name__ = ["com","inq","flash","client","chatskins","SndMgr"];
/** @private @type {com.inq.ui.Button} */
com.inq.flash.client.chatskins.SndMgr.btnMuteOn = null;
/** @private @type {com.inq.ui.Button} */
com.inq.flash.client.chatskins.SndMgr.btnMuteOff = null;
/** @private @type {string} */
com.inq.flash.client.chatskins.SndMgr.soundURL = null;
/** @private @type {string} */
com.inq.flash.client.chatskins.SndMgr.BTN_CHIME_ON_TEXT = "Chime active";
/** @private @type {string} */
com.inq.flash.client.chatskins.SndMgr.BTN_CHIME_OFF_TEXT = "Chime off";


/**
 * Holds traffic-heavy initialization code to be executed just before playing skin sounds.
 * Purpose: accelerate loading of pre-chat surveys (XForms automatons) by delaying loading of the sound played for new agent messages
 * (such sounds are not needed till chat with an agent is engaged).
 * @private
 */
com.inq.flash.client.chatskins.SndMgr.postInit = {

	runCallback: function () {
		if (com.inq.flash.client.chatskins.SndMgr.postInit.callback) {
			com.inq.flash.client.chatskins.SndMgr.postInit.callback();
			com.inq.flash.client.chatskins.SndMgr.postInit.clear();
		}
	},

	addCallback: function (callback) {
		if (com.inq.flash.client.chatskins.SndMgr.postInit.callback) {
			if (com.inq.utils.ConsoleLogger.detect()) window.console.error("SndMgr.postInit: multiple callbacks not implemented");
		} else {
			com.inq.flash.client.chatskins.SndMgr.postInit.callback = callback;
		}
	},

	clear: function() {
		com.inq.flash.client.chatskins.SndMgr.postInit.callback = null;
	},

	/** @private {Function} */
	callback: null
};


/**
 * _init
 *
 * @public
 * @static
 * @return {boolean}
 */
com.inq.flash.client.chatskins.SndMgr._init = function() {
	com.inq.flash.client.chatskins.SndMgr.lazyInitDone = false;
	com.inq.flash.client.chatskins.SndMgr.postInit.clear();
	//MAYBE com.inq.flash.client.chatskins.SndMgr.divSound = null;
	var div = document.getElementById("divSound");
	/* If the div sound already exists,
	 * then, remove it so that the sound does not play at the drawing of the skin
	 */
	if(div != null) {
		div.innerHTML = "";
		div.parentNode.removeChild(div);
	}
	return true;
};


com.inq.flash.client.chatskins.SndMgr.soundSrc = function (html5AudioSrc) {
	if (html5AudioSrc.indexOf(":/") < 0 && !html5AudioSrc.match(/^\/\//)) {
		var skinPath = com.inq.ui.SkinLoader.getSkinPath();
		html5AudioSrc =	skinPath + (skinPath.charAt(skinPath.length - 1) === "/" ? "" : "/") + html5AudioSrc;
	}
	return html5AudioSrc;
};

/**
 * buildSoundDiv
 * Creates div for holding sound html, only if it does not exist ;
 *
 * @private
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SndMgr.buildSoundDiv = function() {
	var div = document.getElementById("divSound");
	if (null == div) {
		div = document.createElement("DIV");
		div.id = "divSound";
		div.style.cssText = "position:absolute;top:0px;left:0px;display:block;width:1px;height:1px;overflow:hidden;opacity:0.01;filter:alpha(opacity=1)";
		document.body.appendChild(div);
	}

	com.inq.flash.client.chatskins.SndMgr.divSound = div;
	/** init disconnect sound for webrtc */
	com.inq.flash.client.control.WebRTCMgr.initSounds();
	// HTML5 Audio Support
	var html5AudioSrc = com.inq.utils.Util.getConfig("html5AudioSrc", null);
	if (html5AudioSrc != null) {
		html5AudioSrc = com.inq.flash.client.chatskins.SndMgr.soundSrc(html5AudioSrc);

		if (com.inq.utils.Capabilities.isMobile()) {
			try {
				// TODO Check again if necessary.
				com.inq.flash.client.chatskins.SndMgr.audio = top.document.createElement("audio");
				com.inq.flash.client.chatskins.SndMgr.ios = com.inq.flash.client.chatskins.SndMgr.initIosAudio(html5AudioSrc);
			} catch (err) {
				// warn - no sound.
			}
			// TODO move to library function.
		} else if (!com.inq.utils.Util.isIE || com.inq.utils.Util.getIEMajorVer(true) >= 9) {
			// Ready to load a skin sound (e.g. WAV or MP3),
			// but do not load it now as it will delay XForms automatons (pre-chat surveys) on slow connection,
			// especially when it is big WAV file (instead of MP3).
			com.inq.flash.client.chatskins.SndMgr.postInit.addCallback(function () {
				com.inq.flash.client.chatskins.SndMgr.initHTMLAudio(html5AudioSrc);
			});
		}
	}
};

/**
 * Because iOS requires active user event for audio element, we keep user's first touch event and save it to play
 * audio sound.
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SndMgr.initIosAudio = function (html5AudioSrc, loop) {
	var audio = new Audio(html5AudioSrc);
	audio.loop = loop || false;
	var _tdoc = top.document;
	//not sure if you need this, but it's better to be safe
	var iosSnd = {};
	iosSnd.audio = audio;

	/**
	 * immediately clear all listeners to initiate mobile audio
	 * @param e
	 */
	iosSnd.startAudio = function (e) {
		var userAction = false;
		if (e && e.type == "touchstart") {
			userAction = true;
			_tdoc.removeEventListener("touchstart", iosSnd.startAudio, false);
			_tdoc.removeEventListener("keydown", iosSnd.startAudio, false);
		}
		else if (e && e.type == "keydown") {
			userAction = true;
			_tdoc.removeEventListener("keydown", iosSnd.startAudio, false);
			/*
			 * RTDEV-16715
			 * Removed SafariVersion10 from the test condition since it won't work for touchend
			 */
			if (com.inq.utils.Capabilities.isSafariVersion9()) {
				_tdoc.removeEventListener("touchend", iosSnd.startAudio, false);
			}
			else {
				_tdoc.removeEventListener("touchstart", iosSnd.startAudio, false);
			}
		}
		else if (e && e.type == "touchend") {
			userAction = true;
			_tdoc.removeEventListener("touchend", iosSnd.startAudio, false);
			_tdoc.removeEventListener("keydown", iosSnd.startAudio, false);
		}
		iosSnd.audio.play();
		/**
		 * @see RTDEV-14236
		 * Description: Instead of using the "play" eventlistener to pause the audio (if it is from user action),
		 * directly call the  pause() if it is from user action. Using the eventListener for "play" is relatively slow
		 * in android and the music partly plays before being stopped by the pause()
		 */
		if (userAction) {
			iosSnd.audio.pause();
		}
	};

	if (com.inq.utils.Capabilities.isSafariVersion9() || (com.inq.utils.Capabilities.isAndroid() || com.inq.utils.Capabilities.isTablet())) {
		_tdoc.addEventListener("touchend", iosSnd.startAudio, false);
	}
	else {
		_tdoc.addEventListener("touchstart", iosSnd.startAudio, false);
	}
	_tdoc.addEventListener("keydown", iosSnd.startAudio, false);

	return iosSnd;
};

/**
 * Simple HTML5 audio
 *
 * @param src
 */
com.inq.flash.client.chatskins.SndMgr.initHTMLAudio = function (src) {
	/**
	 * base64-encoded sound, embedded into MXML (in form of Data URI, i.e. URI with "data:" protocol).
	 * @type {?string}
	 */
	var audiodatauri = com.inq.utils.Util.getConfig("audiodatauri", null);
	if(audiodatauri) {
		src = audiodatauri;
	}

	com.inq.flash.client.chatskins.SndMgr.audio = new Audio(src);
	com.inq.flash.client.chatskins.SndMgr.audioSupport = com.inq.flash.client.chatskins.SndMgr.audio.play ? true : false ;
};


/**
 * Returns the number equivalent of boolean value "_mute".
 *
 * @public
 * @static
 * @return {number}
 */
com.inq.flash.client.chatskins.SndMgr.getMute = function() {
	return com.inq.flash.client.chatskins.SndMgr._mute ? 1 : 0;
};

/**
 * Returns the boolean value of mute setting.
 * @return {boolean}
 */
com.inq.flash.client.chatskins.SndMgr.isMuted = function() {
	return com.inq.flash.client.chatskins.SndMgr._mute;
};

/**
 * Sets the mute setting in the boolean type of value.
 * Saves this value to the persistent storage.
 *
 * @public
 * @static
 * @param {boolean} mute
 * @return {void}
 */
com.inq.flash.client.chatskins.SndMgr.setMute = function(mute) {
	com.inq.flash.client.chatskins.SndMgr._mute = mute;
	com.inq.flash.client.control.PersistenceManager.SetValue(
		MUTE_SOUND,
		com.inq.flash.client.chatskins.SndMgr.getMute(),
		false,
		true
	);
};


/**
 * Initializes the sound manager by:
 * establishing the <code><div></code> for holding the sound
 * sets up the mute and unmute buttons according the the state of the muting (from the Persistence Manager).
 * sets up the listeners for the mute and unmute buttons
 * loads sound played on new agent message
 *
 * @public
 * @static
 */
com.inq.flash.client.chatskins.SndMgr.init = function() { // Called from MXML skins.
	// Eager initialization = lazyInit + postInit
	com.inq.flash.client.chatskins.SndMgr.lazyInit();
	com.inq.flash.client.chatskins.SndMgr.postInit.runCallback();
};

/**
 * A flag for "SndMgr.lazyInit" to prevents it from being executed twice.
 * <p>Following initialization executions are supported:
 * <ul>
 * <li><code>SndMgr.lazyInit(), SndMgr.PlaySound()</code> - normal case;
 * <li><code>SndMgr.lazyInit(), SndMgr.init(), SndMgr.PlaySound()</code> - happen when skin calls SndMgr.init in "onInitializationComplete" handler;
 * <li><code>SndMgr.init(), SndMgr.PlaySound()</code> - not used currently, may be used if we let skin control SndMgr in full.
 * </ul>
 * @private
 */
com.inq.flash.client.chatskins.SndMgr.lazyInitDone = false;

/**
 * Initializes the sound manager by:
 * establishing the <code><div></code> for holding the sound
 * sets up the mute and unmute buttons according the the state of the muting (from the Persistence Manager).
 * sets up the listeners for the mute and unmute buttons
 *
 * @public
 * @static
 */
com.inq.flash.client.chatskins.SndMgr.lazyInit = function() {
	if (com.inq.flash.client.chatskins.SndMgr.lazyInitDone) {
		return; // Ignore double initialization. Happens when SndMgr.init is called from MXML skins.
	}

	try {
		/** @type {?boolean} */
		var soundEnabled = com.inq.utils.Util.getConfig("soundEnabled", null);
		com.inq.flash.client.chatskins.SndMgr.soundEnabled = !!soundEnabled;

		/** @type {string} */
		var skinPath = com.inq.ui.SkinLoader.getSkinPath();
		/* default value is muted for mobile and unmuted for non mobile */
		/** @type {boolean} */
		var defaultMuteCfg = com.inq.utils.Capabilities.isMobile();
		/** @type {?boolean} */
		var muteCfg = com.inq.utils.Util.getConfig("mute", null);
		if (muteCfg !== null) {
			com.inq.flash.client.chatskins.SndMgr.setMute(muteCfg);
		}
		/** @type {?number} */
		var muteSound = com.inq.flash.client.control.PersistenceManager.GetValue(MUTE_SOUND, null);
		if (muteSound == null) {
			if (soundEnabled !== null) {
				com.inq.flash.client.chatskins.SndMgr.setMute(!soundEnabled);
			} else {
				com.inq.flash.client.chatskins.SndMgr.setMute(defaultMuteCfg);
			}
		} else {
			com.inq.flash.client.chatskins.SndMgr.setMute(!!muteSound);
		}

		com.inq.flash.client.chatskins.SndMgr.soundURL = com.inq.utils.Util.getConfig("soundURL", null);
		if (com.inq.flash.client.chatskins.SndMgr.soundURL != null && com.inq.flash.client.chatskins.SndMgr.soundURL.indexOf(":/") < 0) {
			com.inq.flash.client.chatskins.SndMgr.soundURL = skinPath
				+ ((skinPath.charAt(skinPath.length - 1) === "/" ) ? "" : "/")
				+ com.inq.flash.client.chatskins.SndMgr.soundURL;
		}

		com.inq.flash.client.chatskins.SndMgr.buildSoundDiv();

		com.inq.flash.client.chatskins.SndMgr.swfSoundSuppress = com.inq.utils.Util.getConfig("swfSoundSuppress", false);

		if (com.inq.flash.client.chatskins.SkinControl.isInApplication("btnMuteOff") && com.inq.flash.client.chatskins.SkinControl.isInApplication("btnMuteOn")) {
			/*  sets mute button on and off*/
			com.inq.flash.client.chatskins.SndMgr.btnMuteOn = Application.application.getButton("btnMuteOn");
			com.inq.flash.client.chatskins.SndMgr.btnMuteOff = Application.application.getButton("btnMuteOff");
			com.inq.flash.client.chatskins.SndMgr.fixButtons();
			if (com.inq.flash.client.chatskins.SndMgr.btnMuteOn != null) {
				com.inq.flash.client.chatskins.SndMgr.btnMuteOn.addEventListener(com.inq.events.MouseEvent.CLICK, com.inq.flash.client.chatskins.SndMgr.actionBtnMuteOff);
			}
			if (com.inq.flash.client.chatskins.SndMgr.btnMuteOff != null) {
				com.inq.flash.client.chatskins.SndMgr.btnMuteOff.addEventListener(com.inq.events.MouseEvent.CLICK, com.inq.flash.client.chatskins.SndMgr.actionBtnMuteOn);
			}
		} else if (com.inq.flash.client.chatskins.SkinControl.isInApplication("btnChime")) {
			/*  sets mute button on and off*/
			com.inq.flash.client.chatskins.SndMgr.btnChime = Application.application.getButton("btnChime");
			var mute = com.inq.flash.client.chatskins.SndMgr.isMuted();
			var btnChimeText = mute ? com.inq.utils.Util.getConfig("chimeOffText", com.inq.flash.client.chatskins.SndMgr.BTN_CHIME_OFF_TEXT) : com.inq.utils.Util.getConfig("chimeOnText", com.inq.flash.client.chatskins.SndMgr.BTN_CHIME_ON_TEXT);
			if (com.inq.utils.Capabilities.isIphone() || com.inq.utils.Capabilities.isIpad()) {
				com.inq.flash.client.chatskins.SndMgr.btnChime._img.setAttribute("aria-live", "polite");
				com.inq.flash.client.chatskins.SndMgr.setAriaBusy(true);
				com.inq.flash.client.chatskins.SndMgr.btnChime._img.setAttribute("alt", btnChimeText);
			}
			com.inq.flash.client.chatskins.SndMgr.btnChime._img.setAttribute("aria-pressed", mute ? "false" : "true");
			com.inq.flash.client.chatskins.SndMgr.btnChime._img.setAttribute("title", btnChimeText);
			if (com.inq.flash.client.chatskins.SndMgr.isMuted()) {
				/**
				 * @see https://jira.touchcommerce.com/browse/RTDEV-14236
				 * Bug: When the chime is turned off and the client page refreshed, it comes back with chime turned on
				 * The attribute src is being set on the "input" element and instead of the "img" element.
				 * Fix: set the src attribute on the img element, similar to toggleBtnChime()
				 */
				com.inq.flash.client.chatskins.SndMgr.btnChime._backgroundImage.setAttribute("src", skinPath + com.inq.utils.Util.getConfig("soundOffImgURL", null));
			}
			if (com.inq.flash.client.chatskins.SndMgr.btnChime != null) {
				com.inq.flash.client.chatskins.SndMgr.btnChime.addEventListener(com.inq.events.MouseEvent.CLICK, com.inq.flash.client.chatskins.SndMgr.toggleBtnChime);
			}
		} else {
			// No button means no sound
			com.inq.flash.client.chatskins.SndMgr.setMute(true);
		}
		com.inq.flash.client.chatskins.SndMgr.lazyInitDone = true;
	} catch (e) {
		if (com.inq.utils.ConsoleLogger.detect()) window.console.error("SndMgr.init:", e);
	}
};


/**
 * actionBtnMuteOn
 * Handles mouse event Click from button btnMuteOn.
 * fixes the button views ;
 * sets mute on
 *
 * $type TFun([{ name => me, t => TInst(com.inq.events.MouseEvent,[]), opt => false }],TEnum(Bool,[]))
 * private static function actionBtnMuteOn(me:MouseEvent):Bool
 * @private
 * @static
 * @param {com.inq.events.MouseEvent}  me - the MouseEvent
 * @return {boolean} - true
 */
com.inq.flash.client.chatskins.SndMgr.actionBtnMuteOn = function(me) {
	try {
		if(!com.inq.utils.Capabilities.isMobile()) {
			com.inq.flash.client.chatskins.SndMgr.setMute(true);
			if (com.inq.flash.client.chatskins.SndMgr.btnMuteOn != null && com.inq.flash.client.chatskins.SndMgr.btnMuteOff != null) {
				com.inq.flash.client.chatskins.SndMgr.fixButtons();
			} else if (com.inq.flash.client.chatskins.SndMgr.btnChime != null) {
				com.inq.flash.client.chatskins.SndMgr.toggleBtnChime();
			}
		}
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
		} else throw(e);
	}
	return true;
};


/**
 * actionBtnMuteOff
 * Handles mouse event Click from button btnMuteOff.
 * fixes the button views ;
 * sets mute false
 *
 * $type TFun([{ name => me, t => TInst(com.inq.events.MouseEvent,[]), opt => false }],TEnum(Bool,[]))
 * private static function actionBtnMuteOff(me:MouseEvent):Bool
 * @private
 * @static
 * @param {com.inq.events.MouseEvent}  me - the MouseEvent
 * @return {boolean} - true
 */
com.inq.flash.client.chatskins.SndMgr.actionBtnMuteOff = function(me) {
	try {
		if(!com.inq.utils.Capabilities.isMobile()) {
			com.inq.flash.client.chatskins.SndMgr.setMute(false);
			if (com.inq.flash.client.chatskins.SndMgr.btnMuteOn != null && com.inq.flash.client.chatskins.SndMgr.btnMuteOff != null) {
				com.inq.flash.client.chatskins.SndMgr.fixButtons();
			} else if (com.inq.flash.client.chatskins.SndMgr.btnChime != null) {
				com.inq.flash.client.chatskins.SndMgr.toggleBtnChime();
			}
		}
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
		} else throw(e);
	}
	return true;
};


/**
 * fixButtons
 * Handles shows the correct buttons for mute on or off
 *
 * $type TFun([],TEnum(Void,[]))
 * private static function fixButtons()
 * @private
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SndMgr.fixButtons = function() {
	if (com.inq.flash.client.chatskins.SndMgr.btnMuteOn != null && com.inq.flash.client.chatskins.SndMgr.btnMuteOff != null) {
		com.inq.flash.client.chatskins.SndMgr.btnMuteOn.setVisible(com.inq.flash.client.chatskins.SndMgr.isMuted());
		com.inq.flash.client.chatskins.SndMgr.btnMuteOff.setVisible(!com.inq.flash.client.chatskins.SndMgr.btnMuteOn.getVisible());/*  btnMuteOff visibility should be the opposite of btnMuteOn*/
	}
};

/**
 * toggleBtnChime
 * Toggle Chime button on and off
 *
 * @private
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SndMgr.toggleBtnChime = function () {
	if (com.inq.flash.client.chatskins.SndMgr.btnChime != null) {
		var objCheck = com.inq.flash.client.chatskins.SndMgr.btnChime._img;
		var _newim = com.inq.flash.client.chatskins.SndMgr.btnChime._backgroundImage;

		/** @type {string} */
		var skinPath = com.inq.ui.SkinLoader.getSkinPath();
		/** @type {string} */
		var btnChimeOnText = com.inq.utils.Util.getConfig("chimeOnText", com.inq.flash.client.chatskins.SndMgr.BTN_CHIME_ON_TEXT);
		/** @type {string} */
		var btnChimeOffText = com.inq.utils.Util.getConfig("chimeOffText", com.inq.flash.client.chatskins.SndMgr.BTN_CHIME_OFF_TEXT);
		if (objCheck.getAttribute("aria-busy") === "true") {
			com.inq.flash.client.chatskins.SndMgr.setAriaBusy(false);
		}
		if (com.inq.flash.client.chatskins.SndMgr.isMuted()) {
			if (com.inq.utils.Capabilities.isIphone() || com.inq.utils.Capabilities.isIpad()) {
				com.inq.flash.client.chatskins.SndMgr.toggleBtnAnnouncedIos(btnChimeOnText, 500);
			} else {
				com.inq.flash.client.chatskins.SndMgr.toggleBtnAnnounced(btnChimeOnText);
			}
			_newim.setAttribute('src', skinPath + com.inq.utils.Util.getConfig("soundOnImgURL", null));
			objCheck.setAttribute('aria-pressed', 'true');
			com.inq.flash.client.chatskins.SndMgr.setMute(false);
		} else {
			if (com.inq.utils.Capabilities.isIphone() || com.inq.utils.Capabilities.isIpad()) {
				com.inq.flash.client.chatskins.SndMgr.toggleBtnAnnouncedIos(btnChimeOffText);
			} else {
				com.inq.flash.client.chatskins.SndMgr.toggleBtnAnnounced(btnChimeOffText);
			}
			_newim.setAttribute('src', skinPath + com.inq.utils.Util.getConfig("soundOffImgURL", null));
			objCheck.setAttribute('aria-pressed', 'false');
			com.inq.flash.client.chatskins.SndMgr.setMute(true);
		}
	}
};

/**
 * toggleBtnAnnounced
 * Is used to announce the text of a button and add aria-label attribute
 * Usses addAriaMsg function for announce
 *
 * @public
 * @static
 * @param {string} toggleBtnText - text - for announcement
 * @return {void}
 */
com.inq.flash.client.chatskins.SndMgr.toggleBtnAnnounced = function(toggleBtnText) {
	var toggleBtnText = toggleBtnText ? toggleBtnText : "";
	try {
		var toggleBtn = com.inq.flash.client.chatskins.SndMgr.btnChime._img;
		toggleBtn.setAttribute("title", toggleBtnText);
		com.inq.utils.Timer.delay(function () {
			com.inq.aria.AriaMsg.addAriaMsg(toggleBtnText);
		}, 500);
	} catch (e) {
		if (com.inq.utils.ConsoleLogger.detect()) {
			window.console.error("SndMgr.toggleBtnAnnounced:", e);
		}
	}
};

/**
 * toggleBtnAnnouncedIos
 * Is used to announce the text of a button and add aria-label attribute
 * Announcement works only if toggleBtn has aria-live attribute
 *
 * @public
 * @static
 * @param {string} toggleBtnText - for announcement
 * @param {number} [forceDelay=100] - this should be used if availability attribute is announcing and has a value by default because uses the aria-busy attribute
 * @return {void}
 */
com.inq.flash.client.chatskins.SndMgr.toggleBtnAnnouncedIos = function(toggleBtnText, forceDelay) {
	var toggleBtnText = toggleBtnText ? toggleBtnText : "";
	var forceDelay = (forceDelay || 0) < 100 ? 100 : forceDelay;
	try {
		var toggleBtn = com.inq.flash.client.chatskins.SndMgr.btnChime._img;
		com.inq.utils.Timer.delay(function () {
			toggleBtn.setAttribute("title", toggleBtnText);
			toggleBtn.setAttribute("alt", toggleBtnText);
		}, forceDelay);
	} catch (e) {
		if (com.inq.utils.ConsoleLogger.detect()) {
			window.console.error("SndMgr.toggleBtnAnnouncedIos:", e);
		}
	}
};

/**
 * aria-busy state should be used for elements that use the aria-live attribute to stop announce a text or attribute value
 *
 * @public
 * @static
 * @param {boolean}  val - new aria-busy value, true if undefined
 * @return {void}
 */
com.inq.flash.client.chatskins.SndMgr.setAriaBusy = function(val) {
	if (typeof val === "undefined") {
		val = true;
	}
	if (com.inq.flash.client.chatskins.SndMgr.btnChime != null) {
		com.inq.flash.client.chatskins.SndMgr.btnChime._img.setAttribute("aria-busy", val);
	}
};

/**
 * PlaySound
 * Plays sound by inserting html into the "soundSwf" div
 *
 *    TODO - remove all unnecessary flags and get switch (on/off) value from Dom object directly.
 *
 * @public
 * @static
 * @param {string}  soundURL - sound to play, if null, then play default sound
 * @return {void}
 */
com.inq.flash.client.chatskins.SndMgr.PlaySound = function(soundURL) {
	com.inq.flash.client.chatskins.SndMgr.postInit.runCallback();

	if((com.inq.utils.Capabilities.isMobile()) && typeof com.inq.flash.client.chatskins.SndMgr.audio != "undefined") {
		// RTDEV-8131
		if (com.inq.flash.client.chatskins.SndMgr.btnChime != null) {
			if (!com.inq.flash.client.chatskins.SndMgr.isMuted()) {
				com.inq.flash.client.chatskins.SndMgr.ios.startAudio();
			}
		} else {
			com.inq.flash.client.chatskins.SndMgr.ios.startAudio();
		}
		return;
	}

	if (com.inq.flash.client.chatskins.SndMgr.isMuted() || !com.inq.flash.client.chatskins.SndMgr.soundEnabled) {
		return;
	}

	if (com.inq.flash.client.chatskins.SndMgr.btnChime != null) {
		if (com.inq.flash.client.chatskins.SndMgr.isMuted()) {
			return;
		}
	} else {
		if (com.inq.flash.client.chatskins.SndMgr.btnMuteOn == null || com.inq.flash.client.chatskins.SndMgr.btnMuteOff == null) return;
	}

	com.inq.flash.client.chatskins.SndMgr.play(soundURL);
};

/**
 * Play
 * Plays sound from several sources according to give platform
 *    1. by inserting html into the "soundSwf" div
 *    2. HTML5
 *
 * notes:
 * windows media players 7-10		clsid:6BF52A52-394A-11D3-B153-00C04F79FAA6
 * windows media players older 	clsid:22D6F312-B0F6-11D0-94AB-0080C74C7E95
 * Quick Time						clsid:02BF25D5-8C17-4B23-BC80-D3488ABDDC6B
 *
 * Things to remember in OBJECT
 * 1) Do NOT include the CODEBASE, not including will stop the asking for the installation of the plugin
 * 2) Please WMODE = transparent so we do not see the control
 *
 * Example
 * <code>
 * <OBJECT CLASSID="clsid:02BF25D5-8C17-4B23-BC80-D3488ABDDC6B" WIDTH="200" HEIGHT="15">
 * <PARAM name="SRC" VALUE="http://teachers.esu10.org:8000/gems/manilaSupport/trumanjapan.mp3" />
 * <PARAM name="AUTOPLAY" VALUE="false" />
 * <param name="wmode" value="transparent" />
 * <EMBED SRC="http://teachers.esu10.org:8000/gems/manilaSupport/trumanjapan.mp3" WIDTH="200" HEIGHT="15" AUTOPLAY="false">
 * </EMBED>
 * </OBJECT>
 * </code>
 *
 * @protected
 * @static
 * @param {string}  soundURL - sound to play, if null, then play default sound
 * @return {void}
 */
com.inq.flash.client.chatskins.SndMgr.play = function(soundURL) {

	if ((com.inq.utils.Capabilities.isMobile()) && typeof com.inq.flash.client.chatskins.SndMgr.audio != "undefined") {
		com.inq.flash.client.chatskins.SndMgr.ios.startAudio();
		return;
	}

	// TODO library function.
	if (com.inq.flash.client.chatskins.SndMgr.audioSupport) {
		com.inq.flash.client.chatskins.SndMgr.audio.play();
		return;
	}

	if (soundURL == null) {
		soundURL = com.inq.flash.client.chatskins.SndMgr.soundURL;
		if (soundURL == null) {
			return;
		}
	}

	try {
		if(null != com.inq.flash.client.chatskins.SndMgr.divSound) {
			/** @type {string} */
			var cidSwf = "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000";
			/** @type {string} */
			var cidQT = "clsid:02BF25D5-8C17-4B23-BC80-D3488ABDDC6B";
			/** @type {string} */
			var cidMP = "clsid:6BF52A52-394A-11D3-B153-00C04F79FAA6";
			/** @type {string} */
			var swfPath = com.inq.utils.Util.getConfig("soundSwf",null);
			/** @type {string} */
			var soundExt = null;

			/* Obtain the extension of the sound file */
			try {
				soundExt = soundURL.split(".").pop();
			} catch( e ) {
				if( js.Boot.__instanceof(e,Error) ) {
					soundExt = "mp3";
				} else throw(e);
			}
			soundExt = soundExt != null?soundExt.toLowerCase():"mp3";

			/* if the sound is wav or mp3 and we have IE we can play the sound via the BGSOUND tag */
			if(soundURL != null && (soundExt == "mp3" || soundExt == "wav")) {
				/** @type {Element} */
				var sounder = window.document.getElementById("inqSounder");
				if(sounder == null) {
					/** @type {Element} */
					var bgsound = bgsound = document.createElement("BGSOUND");
					bgsound.id = "inqSounder";
					bgsound.loop = "1";
					document.body.insertBefore(bgsound, null);
				}
				sounder = window.document.all["inqSounder"];
				if (sounder != null && sounder.src != null) {
					sounder.src = soundURL;
					return;
				}
			}

			if(null == swfPath) swfPath = "PlaySoundFile.swf";
			swfPath = com.inq.ui.SkinLoader.getSkinPath() + "/" + swfPath;
			var /** @type {string} */ flashvars = soundURL == null?null:"soundURL=" + soundURL + " ";

			var /** @type {number} */ randomNumber = Math.floor(Math.random() * 1000);
			var /** @type {string} */ swfEmbed = document.all
				?""
				:"<embed src=\"" + swfPath + "\" quality=\"high\" play=\"true\" loop=\"false\" scale=\"showall\" "
					+ (flashvars != null?"flashvars=\"" + flashvars + "\" ":"") +
					"wmode=\"transparent\" devicefont=\"false\" bgcolor=\"#ffffff\" name=\"PlaySoundFile\" menu=\"false\" allowfullscreen=\"false\" allowscriptaccess=\"sameDomain\" salign=\"\" type=\"application/x-shockwave-flash\" width=\"10\" align=\"middle\" height=\"10\"> \n"
				;/* Create the SWF for playing the sound */

			/* Search for the extension in the mimetype list */
			/** @type {boolean} */
			var haveMime = com.inq.flash.client.chatskins.SndMgr.searchForMimeType(soundExt);
			if(!haveMime && soundExt == "mp3") haveMime = com.inq.flash.client.chatskins.SndMgr.searchForMimeType("mp4");
			if(haveMime) swfEmbed = "<embed src=\"" + soundURL + "\" wmode=\"transparent\" autostart=\"true\" loop=\"false\" width=\"1\" height=\"1\" controller=\"false\">" + "</embed>";
			else if(com.inq.flash.client.chatskins.SndMgr.swfSoundSuppress) swfEmbed = "";/* If we have a MIME for playing sound, use it inplace of the SWF */

			/** @type {string} */
			var swfHtml = "<object classid=\"" + cidSwf + "\" name=\"sound" + randomNumber + "\"" + " data=\"" + swfPath + "\"" + " width=\"2\" " + " height=\"2\" " + " id=\"PlaySoundFile\"" + " align=\"middle\">" +
				" <param name=\"allowScriptAccess\" value=\"sameDomain\" />" +
				" <param name=\"allowFullScreen\" value=\"false\" />" +
				" <param name=\"movie\" value=\"" + swfPath + "\" />" +
				" <param name=\"loop\" value=\"false\" />" +
				" <param name=\"menu\" value=\"false\" />" +
				" <param name=\"quality\" value=\"high\" />" +
				" <param name=\"wmode\" value=\"transparent\" />" +
				" <param name=\"bgcolor\" value=\"#FF000\" />" +
				(soundURL != null?" <param name=\"flashvars\" value=\"soundURL=" + soundURL + "\" />":"") +
				(flashvars != null?" <param name=\"flashvars\" value=\"" + flashvars + "\" />":"") + swfEmbed + "</object>";

			/* Lets wrap this with Media Player */
			if(soundURL != null) swfHtml = "<object classid=\"" + cidMP + "\" name=\"sound" + randomNumber + "\"" + " data=\"" + soundURL + "\"" + " width=\"1\" " + " height=\"1\" " + " id=\"PlaySoundFileMediaPlayer\"" + " align=\"middle\">" +
				" <param name=\"wmode\" value=\"transparent\" />" +
				" <PARAM name=\"SRC\" VALUE=\"" + soundURL + "\">" +
				" <PARAM name=\"AUTOPLAY\" VALUE=\"1\">" +
				" <PARAM name=\"Filename\" VALUE=\"" + soundURL + "\">" +
				" <PARAM name=\"AutoSize\" VALUE=\"0\">" +
				" <PARAM name=\"AutoStart\" VALUE=\"0\">" +
				" <PARAM name=\"ClickToPlay\" VALUE=\"1\">" +
				" <PARAM name=\"PlayCount\" VALUE=\"1\">" +
				" <PARAM name=\"ShowControls\" VALUE=\"0\">" +
				" <PARAM name=\"ShowAudioControls\" VALUE=\"0\">" +
				" <PARAM name=\"ShowDisplay\" VALUE=\"0\">" +
				" <PARAM name=\"ShowPositionControls\" VALUE=\"-1\">" +
				" <PARAM name=\"ShowStatusBar\" VALUE=\"0\">" +
				" <PARAM name=\"ShowTracker\" VALUE=\"0\">" + "\n" + swfHtml + "\n" + "</object>";

			/* Lets wrap this with QuickTime */
			if(soundURL != null) swfHtml = "<object classid=\"" + cidQT + "\" name=\"sound" + randomNumber + "\"" + " data=\"" + soundURL + "\"" + " width=\"2\" " + " height=\"2\" " + " id=\"PlaySoundFileQT\"" + " align=\"middle\">" +
				" <param name=\"wmode\" value=\"transparent\" />" +
				" <PARAM name=\"SRC\" VALUE=\"" + soundURL + "\">" +
				" <PARAM name=\"AUTOPLAY\" VALUE=\"true\">" +
				"<param name=\"controller\" value=\"false\">" + "\n" + swfHtml + "\n" + "</object>";
			com.inq.flash.client.chatskins.SndMgr.divSound.innerHTML = swfHtml;
		}
	} catch (e) {
		if (com.inq.utils.ConsoleLogger.detect()) window.console.error("SndMgr.play:", e);
	}
};


/**
 * searchForMimeType
 * Checks the browser for a mime type, this is for GECKO engines only
 *
 * $type TFun([{ name => mimeType, t => TInst(String,[]), opt => false }],TEnum(Bool,[]))
 * private static function searchForMimeType(mimeType:String):Bool
 * @private
 * @static
 * @param {string}  mimeType - the name (String) of the type of sound file from the extension
 * @return {boolean} - true/false - Boolean whether-or-not the file has a plugin. If IE always returns false
 */
com.inq.flash.client.chatskins.SndMgr.searchForMimeType = function(mimeType) {
	/** @type {Array} */
	var mimes = window.navigator["mimeTypes"];
	if(mimes == null || mimes.length < 1) return false;
	var /** @type {number} */ mix, /** @type {number} */ six;/*  indexes for mimes and suffixes*/
	var /** @type {number} */ _g1 = 0, /** @type {number} */ _g = mimes.length;
	while(_g1 < _g) {
		var /** @type {number} */ mix1 = _g1++;
		var /** @type {Array} */ suffixes = mimes[mix1].suffixes.split(",");
		if(suffixes == null || suffixes.length < 1) continue;
		var /** @type {number} */ _g3 = 0, /** @type {number} */ _g2 = suffixes.length;
		while(_g3 < _g2) {
			var /** @type {number} */ six1 = _g3++;
			if(mimeType == suffixes[six1]) return true;
		}
	}
	return false;
};

/** @type {com.inq.flash.client.chatskins.SndMgr} */
com.inq.flash.client.chatskins.SndMgr.prototype.__class__ = com.inq.flash.client.chatskins.SndMgr;
/** @private {HTMLElement} */
com.inq.flash.client.chatskins.SndMgr.divSound = null;

/** @private @type {boolean} */
com.inq.flash.client.chatskins.SndMgr._initialized = com.inq.flash.client.chatskins.SndMgr._init();

/** @private @type {boolean} */
com.inq.flash.client.chatskins.SndMgr._mute = false;

/** @private @type {boolean} */
com.inq.flash.client.chatskins.SndMgr.soundEnabled = true;

/** @private @type {boolean} */
com.inq.flash.client.chatskins.SndMgr.swfSoundSuppress = false;

